import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { blogAPI } from '../services/api';
import API_BASE_URL from '../config/api';
import LoadingScreen from '../components/LoadingScreen';
import { useLang } from '../context/LanguageContext';
import './BlogStyles.css';
import './BlogPost.css';

const BlogPost = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { nl } = useLang();
  const L = (obj, field) => (nl && obj?.[field + '_nl']) || obj?.[field] || '';
  const [blog, setBlog] = useState(null);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [blogPageData, setBlogPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          const blogResponse = await blogAPI.getById(id);
          setBlog(blogResponse.data.data);
        }
        const blogsResponse = await blogAPI.getAll();
        setRecentBlogs((blogsResponse.data.data || []).slice(0, 10));
        
        const blogPageResponse = await fetch(`${API_BASE_URL}/api/blogs/page`);
        const blogPageResult = await blogPageResponse.json();
        if (blogPageResult.success) {
          setBlogPageData(blogPageResult.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) return <LoadingScreen />;
  if (!blog) return <div>Blog not found</div>;

  return (
    <>
      <section className="blog-banner" style={{
        backgroundImage: blogPageData?.bannerSection?.image 
          ? `url(${blogPageData.bannerSection.image})` 
          : 'url(https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=1200&h=400&fit=crop)'
      }}>
        <div className="banner-overlay"></div>
        <div className="blog-banner-content">
          <h1>{L(blog, 'title')}</h1>
          <p>{nl ? 'Lees onze laatste inzichten en updates' : 'Read our latest insights and updates'}</p>
        </div>
      </section>

      <section className="specialization-section" style={{ paddingTop: '20px' }}>
        <div className="container">
          <div className="blog-layout">
            <article className="blog-main">
              <div className="blog-hero-image">
                <img src={blog.image || 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=400&fit=crop'} alt={L(blog, 'title')} />
              </div>
              
              <div className="blog-meta">
                <span className="blog-category">{L(blog, 'category') || 'Technology'}</span>
                <span className="blog-date">{new Date(blog.createdAt).toLocaleDateString()}</span>
                <span className="blog-author">{nl ? 'Door' : 'By'} {blog.author || 'Admin'}</span>
                <span className="blog-read-time">{blog.readTime || (nl ? '5 min lezen' : '5 min read')}</span>
              </div>
              
              <h1 className="blog-title">{L(blog, 'title')}</h1>
              
              <div className="blog-content" dangerouslySetInnerHTML={{ __html: L(blog, 'content') }} />
            </article>
            
            <aside className="blog-sidebar">
              <h3 className="sidebar-title">{nl ? 'Recente berichten' : 'Recent Posts'}</h3>
              {recentBlogs.map(post => (
                <div key={post._id} className="recent-post">
                  <div className="recent-post-image">
                    <img src={post.image || 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=80&h=60&fit=crop'} alt={(nl && post.title_nl) || post.title} />
                  </div>
                  <div className="recent-post-content">
                    <Link to={`/blog-post/${post.slug}`} className="recent-post-title">{(nl && post.title_nl) || post.title}</Link>
                    <div className="recent-post-date">{new Date(post.createdAt).toLocaleDateString()}</div>
                  </div>
                </div>
              ))}
            </aside>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogPost;
